/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue/dist/vue.esm.js';
import axios from 'axios';
import bus from '../../bus.js';
import { mapState } from 'vuex';
import PlayImage from '@/components/elements/PlayImage.vue';
import PauseImage from '@/components/elements/PauseImage.vue';
import DownloadButton from '@/components/elements/DownloadButton.vue';
import ShareButton from '@/components/elements/ShareButton.vue';
import CommentButton from '@/components/elements/CommentButton.vue';
import BeatComments from '@/components/BeatComments.vue';
import Equalizer from '@/components/elements/Equalizer.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faPlay);
library.add(faPause);
Vue.component('font-awesome-icon', FontAwesomeIcon)

const __vue_script__ = {
	components: {
		PlayImage,
		PauseImage,
		DownloadButton,
		ShareButton,
		CommentButton,
		BeatComments,
		Equalizer,
	},
	data() {
		return {
			beat: {},
			audioSources: [],
			beatsOnDeck: [],
			recommendedTracks: [],
			pageName: '',
			index: 0,
			genres: false,
			genreSlug: '',
		}
	},
	methods: {
		async copyURL() {
			const copiedPopover = document.querySelector('#copied-popover');
			const text = this.currentURL;
			const type = "text/plain";
			const blob = new Blob([text], { type });
			const data = [new ClipboardItem({ [type]: blob })];

			try {
				await navigator.clipboard.write(data);
				copiedPopover.showPopover();
				setTimeout( () => {
					copiedPopover.hidePopover();
				}, 1600 );
			} catch(error) {
				console.log(error);
			}
		},	
		hideSharePopover() {
			
			this.$refs.shareBeatPopover.hidePopover();
		},
		updateSong( index, id ) {
			let vm = this;

			if ( this.isPlaying && id === this.$store.getters.getSongID ) {
				bus.$emit( 'pauseSong' );
				return;
			}
			
			if ( id === this.$store.getters.getSongID && ! this.isPlaying) {
				// playing same song again, just resume playback.
				bus.$emit( 'resumeSong' );
				return;
			}

			//emit audiosourcelist / playlist
			bus.$emit( 'updatePlaylist', vm.audioSources );
			bus.$emit( 'updateSong', index, id );
			this.$store.commit( 'updateSongID', id );
		},
		openFreeDownloadModal( track ) {
			bus.$emit( 'openDownloadModal', track );
		},
		
		async fetchData() {
			let vm = this;
			let response = await axios.get( ui_data.homeUrl  + '/wp-json/beatstore/v1/beats/subsite/' + vm.$route.params.name );
			let beat         = response.data;
			vm.beat          = beat;
			vm.beat['index'] = 0;
			vm.pageName      = vm.beat.title;
			vm.beatsOnDeck = [];
			vm.beatsOnDeck.push(vm.beat);
			bus.$emit( 'beatsOnDeck', vm.beatsOnDeck );
			vm.genres = vm.beat.genre;
			vm.genreSlug = vm.beat.genreslug[0];
			
			let recomendResponse = await axios.get( ui_data.homeUrl + '/wp-json/beatstore/v1/beats/subsite/recommended/' + vm.$route.params.name );
			let beats = recomendResponse.data;
			let i = 1;
			
			if ( ! beats ) {
				vm.recommendedTracks = [];
				return;
			}
			
			beats.forEach( function( track ) {
				//Add index to beats
				track['index'] = i;
				vm.beatsOnDeck.push(track);
				i++;
			});
			vm.recommendedTracks = beats;
		},
	},
	created() {
		this.$watch(
			() => this.$route.params.name,
			this.fetchData,
			// fetch the data when the view is created and the data is
			// already being observed
			{ 
				immediate: true 
			}
		)

		document.addEventListener('keydown', (event) => {
			if ( event.key === 'Escape' ) {
				this.hideSharePopover();
			}
		})
	},
	updated() {

		if ( document.querySelector( '.ui-single-beat__cart-button input.edd-add-to-cart.edd-no-js' ) ) {
			const inputButtonEl = document.querySelector( '.ui-single-beat__cart-button input.edd-add-to-cart.edd-no-js' );
			const linkEl        = document.querySelector( '.ui-single-beat__cart-button .edd_purchase_submit_wrapper a.edd-add-to-cart' );
			inputButtonEl.style.display = 'none';
			linkEl.style.display        = 'inline-block';
		}
	},
	computed: {
		...mapState({
			isPlaying: state => state.isPlaying,
		}),
		currentURL() {
			return window.location.href;
		}
	},
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-beat"},[_c('div',{staticClass:"single-beat__top"},[_c('div',{staticClass:"beat-featured-image-wrap"},[(_vm.beat.image)?_c('img',{staticClass:"beat-featured-image__mobile",attrs:{"src":_vm.beat.image,"alt":_vm.beat.title,"height":"387","width":"387"}}):_c('div',{staticClass:"skeleton skeleton-beat-featured-image__mobile"})]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"single-beat__left"},[_c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"You are here:"}},[_c('ol',{attrs:{"itemscope":"","itemtype":"https://schema.org/BreadcrumbList"}},[_c('li',{attrs:{"itemprop":"itemListElement","itemscope":"","itemtype":"https://schema.org/ListItem"}},[_c('router-link',{attrs:{"itemprop":"item","to":"/"}},[_c('span',{attrs:{"itemprop":"name"}},[_vm._v("Home")])]),_vm._v(" "),_c('meta',{attrs:{"itemprop":"position","content":"1"}})],1),_vm._v(" "),_c('li',{attrs:{"itemprop":"itemListElement","itemscope":"","itemtype":"https://schema.org/ListItem"}},[_c('router-link',{attrs:{"to":"/beats/","itemprop":"item"}},[_c('span',{attrs:{"itemprop":"name"}},[_vm._v("Beats")])]),_vm._v(" "),_c('meta',{attrs:{"itemprop":"position","content":"2"}})],1),_vm._v(" "),(_vm.beat && _vm.genres.length)?_c('li',{attrs:{"itemprop":"itemListElement","itemscope":"","itemtype":"https://schema.org/ListItem"}},[_c('router-link',{attrs:{"to":{ name: 'genre', params: { genre: _vm.genreSlug }},"itemprop":"item"}},[_c('span',{attrs:{"itemprop":"name"}},[_vm._v(_vm._s(_vm.genres[0]))])]),_vm._v(" "),_c('meta',{attrs:{"itemprop":"position","content":"3"}})],1):_vm._e(),_vm._v(" "),_c('li',{attrs:{"itemprop":"itemListElement","itemscope":"","itemtype":"https://schema.org/ListItem"}},[_c('span',{attrs:{"itemprop":"name"}},[_vm._v(_vm._s(_vm.beat.title))]),_vm._v(" "),_c('meta',{attrs:{"itemprop":"position","content":"4"}})])])]),_vm._v(" "),_c('div',{staticClass:"beat-featured-image-wrap"},[(_vm.beat.image)?_c('img',{staticClass:"beat-featured-image__desktop",attrs:{"src":_vm.beat.image,"alt":_vm.beat.title,"height":"387","width":"387"}}):_c('div',{staticClass:"skeleton skeleton-beat-featured-image",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('ul',{staticClass:"beat-action-buttons"},[_c('li',[_c('ShareButton',{attrs:{"beat":_vm.beat}}),_vm._v(" "),(_vm.beat.free_download)?_c('button',{staticClass:"btn-reset",attrs:{"title":"Download"},on:{"click":function($event){return _vm.openFreeDownloadModal(_vm.beat)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24px","viewBox":"0 -960 960 960","width":"24px","fill":"#111"}},[_c('path',{attrs:{"d":"M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"}})])]):_vm._e(),_vm._v(" "),(_vm.beat.comments_open)?_c('CommentButton'):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"beat-info"},[(_vm.beat.title)?_c('h1',{staticClass:"beat-title",domProps:{"innerHTML":_vm._s(_vm.beat.title)}}):_c('div',{staticClass:"skeleton skeleton-beat-title",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"beat-info__genre-and-bpm"},[(_vm.genres.length)?_c('span',{staticClass:"beat-info__genre"},[_c('span',[_vm._v("Genre")]),_vm._v(" "),_vm._l((_vm.genres),function(genre,index){return _c('span',{staticClass:"bold"},[_c('span',{domProps:{"innerHTML":_vm._s(genre)}}),(index+1 < _vm.genres.length)?_c('span',[_vm._v(", ")]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.beat.bpm)?_c('span',{staticClass:"beat-info__bpm"},[_c('span',[_vm._v("BPM:")]),_vm._v(" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.beat.bpm))])]):_vm._e(),_vm._v(" "),(_vm.beat.key)?_c('span',{staticClass:"beat-info__key"},[_c('span',[_vm._v("Key:")]),_vm._v(" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.beat.key))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"beat-info__date-added"},[_c('span',[_vm._v("Date:")]),_vm._v(" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.beat.date))])])]),_vm._v(" "),(_vm.beat.tags)?_c('ul',{staticClass:"product-tags"},_vm._l((_vm.beat.tags),function(tag){return _c('li',[_c('router-link',{staticClass:"hashtag",attrs:{"to":{ path: ("/beats/tag/" + (tag.slug) + "/") },"rel":"tag"}},[_vm._v("#"+_vm._s(tag.name))])],1)}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"beat-controls"},[_c('button',{staticClass:"ui-single-beat__play-button",on:{"click":function($event){return _vm.updateSong(0, _vm.beat.id)}}},[(_vm.isPlaying && _vm.beat.id == this.$store.state.songID)?_c('span',[_vm._v("\n\t\t\t\t\t\t\tPause "),_c('font-awesome-icon',{attrs:{"icon":['fas', 'pause']}})],1):_c('span',[_vm._v("\n\t\t\t\t\t\t\tPlay "),_c('font-awesome-icon',{attrs:{"icon":['fas', 'play']}})],1)]),_vm._v(" "),_c('div',{staticClass:"ui-single-beat__cart-button",domProps:{"innerHTML":_vm._s(_vm.beat.cartBtns)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.beat.content),expression:"beat.content"}],staticClass:"beat-description",domProps:{"innerHTML":_vm._s(_vm.beat.content)}})])])]),_vm._v(" "),(_vm.beat.comments_open)?_c('BeatComments',{attrs:{"beat":_vm.beat}}):_vm._e(),_vm._v(" "),(_vm.recommendedTracks && _vm.recommendedTracks.length > 0)?_c('div',{staticClass:"recommended-tracks"},[_c('h2',[_vm._v("Recommended Tracks")]),_vm._v(" "),_c('div',{staticClass:"container"},_vm._l((_vm.recommendedTracks),function(product){return _c('div',{key:product.id,staticClass:"beat"},[_c('div',{staticClass:"image_grid--container",on:{"click":function($event){return _vm.updateSong( product.index, product.id )}}},[_c('picture',[_c('source',{attrs:{"media":"(min-width: 768px)","srcset":product.image_grid_medium}}),_vm._v(" "),_c('source',{attrs:{"media":"(min-width: 1201px)","srcset":product.image_grid}}),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(product.image_grid),expression:"product.image_grid"}],staticClass:"featured-image",attrs:{"alt":product.title,"height":"409","width":"409"}})]),_vm._v(" "),_c('div',{staticClass:"play-button"},[_c('PlayImage')],1),_vm._v(" "),(product.id == _vm.$store.state.songID && _vm.isPlaying == true)?[_c('Equalizer')]:_vm._e()],2),_vm._v(" "),_c('router-link',{staticClass:"title",attrs:{"to":product.path},domProps:{"innerHTML":_vm._s(product.title)}}),_vm._v(" "),(product.genre)?_c('p',{staticClass:"featured-beat__genre",domProps:{"innerHTML":_vm._s(product.genre[0])}}):_vm._e()],1)}),0)]):_vm._e(),_vm._v(" "),_c('div',{ref:"shareBeatPopover",attrs:{"id":"share-beat-popover","popover":""}},[_c('h2',[_vm._v("Share Track")]),_vm._v(" "),_c('div',{staticClass:"flex"},[(_vm.beat.image)?_c('img',{attrs:{"src":_vm.beat.image,"loading":"lazy","width":"64","height":"64"}}):_vm._e(),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.beat.title))])]),_vm._v(" "),_c('label',[_vm._v("Full URL")]),_vm._v(" "),_c('div',{staticClass:"copy-url-input-wrap"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512"}},[_c('path',{attrs:{"d":"M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentURL),expression:"currentURL"}],attrs:{"type":"text","placeholder":"URL to copy"},domProps:{"value":(_vm.currentURL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentURL=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn-reset copy-url",attrs:{"type":"button"},on:{"click":_vm.copyURL}},[_vm._v("Copy URL")])]),_vm._v(" "),_c('button',{staticClass:"btn-reset btn-exit-popover",attrs:{"aria-label":"Close Popover"},on:{"click":_vm.hideSharePopover}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xml:space":"preserve","viewBox":"0 0 122.878 122.88","height":"16","width":"16"}},[_c('path',{attrs:{"d":"M1.426 8.313a4.87 4.87 0 0 1 6.886-6.886l53.127 53.127 53.127-53.127a4.87 4.87 0 1 1 6.887 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.868 4.868 0 1 1-6.886-6.886l53.127-53.128L1.426 8.313z"}})])])]),_vm._v(" "),_c('div',{attrs:{"id":"copied-popover","popover":""}},[_vm._v("\n\t\tURL Copied to clipboard.\n\t")])],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5851f7ae_0", { source: ".edd_download_purchase_form .edd_price_options li{padding:4px 0}.recommended-tracks{background-color:#f4f4f4}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SingleBeat.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__